import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__grid">
          {/* Brand */}
          <div>
            <div className="footer__logo">
              <picture><source srcSet="/logo.webp" type="image/webp" /><img src="/logo.png" alt="The Cruiser Shop – Kerékpár Szaküzlet Baja" /></picture>
            </div>
            <p className="footer__desc">
              Kerékpár szaküzlet és szerviz Baján, Bács-Kiskun megyében. Elektromos, túra, MTB, városi és gyermek kerékpárok. Személyes tanácsadás, szerviz, garancia.
            </p>
            <div className="footer__social" style={{ marginTop: 20 }}>
              <a href="https://www.facebook.com/p/Ker%C3%A9kp%C3%A1rszak%C3%BCzlet-%C3%A9s-Szerviz-Baja-100064352425586/?locale=hu_HU" target="_blank" rel="noreferrer" className="footer__social-btn" aria-label="Facebook">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/>
                </svg>
              </a>
              <a href="https://www.instagram.com/kerekpar_szakuzlet_06702107706/" target="_blank" rel="noreferrer" className="footer__social-btn" aria-label="Instagram">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                  <circle cx="12" cy="12" r="4"/>
                  <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Kerékpárok */}
          <div>
            <p className="footer__head">Kerékpárok Baján</p>
            <nav className="footer__links">
              <Link to="/kerekparok" className="footer__link">Összes kerékpár</Link>
              <Link to="/elektromos-kerekpar" className="footer__link">Elektromos kerékpár</Link>
              <Link to="/tura-kerekpar" className="footer__link">Túrakerékpár</Link>
              <Link to="/varosi-kerekpar" className="footer__link">Városi kerékpár</Link>
              <Link to="/gyermek-kerekpar" className="footer__link">Gyermek kerékpár</Link>
              <Link to="/mtb-kerekpar" className="footer__link">MTB kerékpár</Link>
              <Link to="/haromkereku-kerekpar" className="footer__link">Háromkerekű</Link>
              <Link to="/kerekpar-baja" className="footer__link">Kerékpár Baja</Link>
            </nav>
          </div>

          {/* Üzlet */}
          <div>
            <p className="footer__head">Üzletünk</p>
            <nav className="footer__links">
              <Link to="/rolunk" className="footer__link">Rólunk</Link>
              <Link to="/szolgaltatasaink" className="footer__link">Szolgáltatások</Link>
              <Link to="/kviz" className="footer__link">Kerékpár kvíz</Link>
              <Link to="/kapcsolat" className="footer__link">Kapcsolat</Link>
            </nav>
          </div>

          {/* Elérhetőség */}
          <div>
            <p className="footer__head">Elérhetőség</p>
            <nav className="footer__links">
              <span className="footer__link" style={{ cursor: 'default' }}>6500 Baja, Czirfusz Ferenc u. 41.</span>
              <a href="mailto:kftfehervari@gmail.com" className="footer__link">kftfehervari@gmail.com</a>
              <a href="tel:+36702107706" className="footer__link">+36 70 210 7706</a>
              <a href="tel:+36705844414" className="footer__link">+36 70 584 4414</a>
              <span className="footer__link" style={{ cursor: 'default' }}>Hétfőtől péntekig: 8:00–17:00</span>
              <span className="footer__link" style={{ cursor: 'default' }}>Szombat: 8:00–12:00</span>
            </nav>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="footer__bottom">
          <span>© {year} The Cruiser Shop – Kerékpár Szaküzlet Baja. Minden jog fenntartva.</span>
          <div style={{ display: 'flex', gap: 24, flexWrap: 'wrap' }}>
            <Link to="/adatvedelem" className="footer__link">Adatvédelmi tájékoztató</Link>
            <Link to="/aszf" className="footer__link">ÁSZF</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
